import { useRoutes } from 'react-router-dom';
import { AppLayout } from '@/layout/AppLayout';
import { Loader } from '@/components/Loader';
import { useAuth } from '@/store/useAppStore';
import { getPublicLinkRoutes, getPublicLinkSidebarLinks } from '@/routes';
import { usePublicLinkSession } from '../hooks/usePublicLinkSession';

/**
 * Enveloppe d'une visite par lien public.
 *
 * Rend strictement l'application client habituelle — même layout, même menu,
 * mêmes écrans — sans compte. Le routeur tourne avec un `basename` réglé sur
 * `/p/<slug>-<token>` (voir App.tsx), si bien que les liens internes du menu et
 * des pages continuent de pointer sur `/projects`, `/tache`, etc. et restent
 * automatiquement sous le préfixe public.
 */

function PublicLinkRoutes() {
  return useRoutes(getPublicLinkRoutes());
}

function CenteredMessage({ title, body }: { title: string; body: string }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-100 bg-white p-10 text-center shadow-sm">
        <h1 className="text-xl font-bold text-slate-900">{title}</h1>
        <p className="mt-2 text-sm text-slate-500">{body}</p>
      </div>
    </div>
  );
}

export function PublicLinkShell() {
  const { isLoading, isError } = usePublicLinkSession();
  const { profile } = useAuth();

  if (isError) {
    return (
      <CenteredMessage
        title="Lien introuvable"
        body="Ce lien n'est plus valide. Rapprochez-vous de votre contact chez Astéroïde."
      />
    );
  }

  // `profile` est alimenté par usePublicLinkSession une fois l'entreprise résolue
  if (isLoading || !profile) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <Loader size="lg" />
      </div>
    );
  }

  return (
    <AppLayout sidebarLinks={getPublicLinkSidebarLinks()}>
      <PublicLinkRoutes />
    </AppLayout>
  );
}
